module.exports = __webpack_public_path__ + "img/down-h.b4026de6.svg";